import { formatBalance } from '@ui/src';
import { useAppSelector } from '@store';
import { PfitByCustomerTypes } from './types';
import ProfitByCustomerItem from './profit-by-customer-item';

import cn from './statistic.module.css';

const ProfitByCustomer = ({
  profitByCustomer,
  baseCurrency,
}: PfitByCustomerTypes): React.JSX.Element => {
  const { currenciesList } = useAppSelector(
    (state) => state.customersDictionaries,
  );

  const currency = currenciesList?.find((item) => item.id === baseCurrency?.id);

  return (
    <div className={cn.profitByCustomerTop}>
      <ProfitByCustomerItem
        title="Fees received"
        value={`${baseCurrency?.name} ${formatBalance(
          profitByCustomer?.feesReceived || 0,
          currency,
        )}`}
      />
      <ProfitByCustomerItem
        title="Total account turnover (base currency)"
        value={`${baseCurrency?.name} ${formatBalance(
          profitByCustomer?.turnover || 0,
          currency,
        )}`}
      />
      <ProfitByCustomerItem
        title="Profit from customer turnover"
        value={`${profitByCustomer?.profitPercent}%`}
        black
      />
    </div>
  );
};

export default ProfitByCustomer;
